import { Editor } from 'grapesjs';
import { faBarcodeScan } from '@fortawesome/pro-solid-svg-icons/faBarcodeScan';
import { EditorComponentDefinition } from '../types';
import { QrcodeDataGrapesComponent } from './qrcode-data-grapes-component';
import { markChildrenWithParentType } from '../../../services/copy-paste/copy-paste-utils';

export const qrCodeComponentDefinition: EditorComponentDefinition = {
  id: 'qrcode',
  icon: faBarcodeScan,
  category: 'Loyalty',
  getLabel: ({ t }) => t('editor.component.qrcode'),
  component: QrcodeGrapesComponent,
  copyPasteHelper: markChildrenWithParentType,
};

export function QrcodeGrapesComponent(editor: Editor) {
  QrcodeDataGrapesComponent(editor);

  const languages = editor.Config?.context?.languages || [];

  editor.DomComponents.addType(qrCodeComponentDefinition.id, {
    model: {
      defaults: {
        attributes: {
          class: 'qlfeditor-qrcode',
        },
        selectable: true,
        draggable: '[data-gjs-type=column]',
        droppable: false,
        traits: [],
        components: [
          {
            type: 'custom-text',
            attributes: {
              style: 'margin-bottom: 1em;',
            },
            draggable: false,
            droppable: false,
            copyable: false,
            i18nAttributes: {
              ...Object.fromEntries(
                languages.map((language: string) => [
                  language,
                  {
                    content: `
                  <div class="ql-snow">
                    <div class="ql-editor">
                      <h1 class="qlfeditor-title ql-align-center">${editor.I18n.t(
                        'editor.qrcode.title',
                        { l: language },
                      )}</h1>
                    </div>
                  </div>
                `,
                  },
                ]),
              ),
            },
          },
          {
            type: 'qrcode-data',
          },
        ],
      },
    },
  });
}
